import "./Footer.css";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import {
  FaLinkedin,
  FaGithub,
  FaInstagram,
  FaYoutube,
  FaArrowRight,
  FaCloud,
  FaDatabase,
  FaCode,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">

      {/* Background Glow */}

      <div className="footer-glow glow1"></div>
      <div className="footer-glow glow2"></div>

      <div className="footer-container">

        {/* ================= CTA ================= */}

        <motion.div
          className="footer-cta"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: .8 }}
        >

          <div>

            <span className="footer-badge">
              Trusted ERP & CRM Partner
            </span>

            <h2>
              Ready to Transform Your Business?
            </h2>

            <p>
              Build scalable NetSuite, Salesforce,
              AI and Web solutions with experts that
              understand enterprise business.
            </p>

          </div>

          <div className="footer-cta-buttons">

            <Link
              to="/schedule-consultation"
              className="footer-primary-btn"
            >
              Schedule Consultation
            </Link>

            <Link
              to="/contact"
              className="footer-secondary-btn"
            >
              Contact Us
            </Link>

          </div>

        </motion.div>

        {/* ================= MAIN GRID ================= */}

        <div className="footer-grid">

          {/* Company */}

          <div className="footer-company">

            <h2>
              IT<span>Seva</span> Hub
            </h2>

            <p>
              Helping businesses modernize
              through NetSuite ERP,
              Salesforce CRM,
              AI Automation,
              and scalable Web Applications.

              We build future-ready digital
              solutions that improve efficiency,
              reduce costs,
              and accelerate growth.
            </p>

            {/* Technology */}

            <div className="tech-stack">

              <span>
                <FaCloud />
                NetSuite
              </span>

              <span>
                <FaDatabase />
                Salesforce
              </span>

              <span>
                <FaCode />
                React
              </span>

            </div>

            {/* Social */}

            <div className="footer-social">

              <a
                href="https://www.linkedin.com/in/itseva-hub-956b14403"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>

              {/* <a href="#">
                <FaGithub />
              </a>

              <a href="#">
                <FaInstagram />
              </a>

              <a href="#">
                <FaYoutube />
              </a> */}

            </div>

          </div>
          {/* ================= Services ================= */}

          <div className="footer-column">

            <h3>Services</h3>

            <ul>

              <li>
                <Link to="/netsuite">
                  <FaArrowRight />
                  NetSuite Consulting
                </Link>
              </li>

              <li>
                <Link to="/netsuite">
                  <FaArrowRight />
                  SuiteScript Development
                </Link>
              </li>

              <li>
                <Link to="/salesforce">
                  <FaArrowRight />
                  Salesforce CRM
                </Link>
              </li>

              <li>
                <Link to="/web-development">
                  <FaArrowRight />
                  Web Development
                </Link>
              </li>

              <li>
                <Link to="/contact">
                  <FaArrowRight />
                  AI Automation
                </Link>
              </li>

              <li>
                <Link to="/contact">
                  <FaArrowRight />
                  API Integrations
                </Link>
              </li>

            </ul>

          </div>

          {/* ================= Company ================= */}

          <div className="footer-column">

            <h3>Company</h3>

            <ul>

              <li>
                <Link to="/">
                  <FaArrowRight />
                  Home
                </Link>
              </li>

              <li>
                <Link to="/blog">
                  <FaArrowRight />
                  Blog
                </Link>
              </li>

              {/* <li>
                <Link to="/contact">
                  <FaArrowRight />
                  About Us
                </Link>
              </li> */}

              {/* <li>
                <Link to="/contact">
                  <FaArrowRight />
                  Careers
                </Link>
              </li> */}

              <li>
                <Link to="/contact">
                  <FaArrowRight />
                  Contact
                </Link>
              </li>

            </ul>

          </div>

          {/* ================= Contact ================= */}

          <div className="footer-contact">

            <h3>Get In Touch</h3>

            <div className="contact-item">

              <FaMapMarkerAlt className="contact-icon" />

              <div>

                <h4>Office</h4>

                <p>
                  Gurgaon, Haryana,
                  India
                </p>

              </div>

            </div>

            <div className="contact-item">

              <FaEnvelope className="contact-icon" />

              <div>

                <h4>Email</h4>

                <p>
                  support@itseva-hub.com
                </p>

              </div>

            </div>

            <div className="contact-item">

              <FaPhoneAlt className="contact-icon" />

              <div>

                <h4>Phone</h4>

                <p>
                  +91 7428568338
                </p>

              </div>

            </div>

            {/* Newsletter */}

            {/* <div className="newsletter">

              <h4>
                Subscribe Newsletter
              </h4>

              <p>
                Get technology updates,
                NetSuite tips,
                Salesforce news,
                and development insights.
              </p>

              <div className="newsletter-box">

                <input
                  type="email"
                  placeholder="Enter your email"
                />

                <button>

                  Subscribe

                </button>

              </div>

            </div> */}

          </div>

        </div>
        {/* ================= Footer Divider ================= */}

        <div className="footer-divider"></div>

        {/* ================= Stats ================= */}

        <motion.div
          className="footer-stats"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: .8 }}
        >

          <div className="stat-box">
            <h2>Start-Up</h2>
            <span>Innovation Driven</span>
          </div>

          <div className="stat-box">
            <h2>Custom</h2>
            <span>Business Solutions</span>
          </div>

          <div className="stat-box">
            <h2>Cloud</h2>
            <span>ERP & CRM Experts</span>
          </div>

          <div className="stat-box">
            <h2>24×7</h2>
            <span>Technical Assistance</span>
          </div>

        </motion.div>

        {/* ================= Technologies ================= */}

        <div className="footer-tech">

          <span>NetSuite ERP</span>

          <span>SuiteScript</span>

          <span>SuiteCommerce</span>

          <span>Salesforce CRM</span>

          <span>Apex Development</span>

          <span>Lightning Web Components</span>

          <span>React.js</span>

          <span>Next.js</span>

          <span>Web Development</span>

          <span>Cloud Solutions</span>

        </div>

        {/* ================= Bottom ================= */}

        <div className="footer-bottom">

          <div className="copyright">

            © {new Date().getFullYear()} ITSeva Hub.

            All Rights Reserved.

          </div>

          <div className="footer-links">

            <Link to="/">
              Home
            </Link>

            <Link to="/blog">
              Blog
            </Link>

            <Link to="/contact">
              Contact
            </Link>

            {/* <Link to="/privacy">
              Privacy Policy
            </Link>

            <Link to="/terms">
              Terms & Conditions
            </Link> */}

          </div>

        </div>

      </div>

      {/* ================= Scroll Top ================= */}

      <button
        className="scroll-top"
        onClick={() =>
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        }
      >
        ↑
      </button>

    </footer>
  );
}